<template>
    <div class="container h-full">
        <div class="overflow-hidden rounded-md">
            <div class="px-4 py-5 space-y-6 bg-white">
                <form
                    class="px-1"
                    @submit.prevent="submitForm"
                >
                    <div class="mt-4">
                        <JetLabel
                            for="name"
                            value="Name"
                        />
                        <JetInput
                            id="name"
                            v-model="form.name"
                            type="text"
                            class="block w-full mt-1"
                            required
                            autofocus
                            autocomplete="name"
                        />
                    </div>

                    <div class="mt-4">
                        <JetLabel
                            for="email"
                            value="Email"
                        />
                        <JetInput
                            id="email"
                            v-model="form.email"
                            type="email"
                            class="block w-full mt-1"
                            required
                        />
                    </div>

                    <div class="mt-4">
                        <JetLabel
                            for="password"
                            value="Password"
                        />
                        <JetInput
                            id="password"
                            v-model="form.password"
                            type="password"
                            class="block w-full mt-1"
                            required
                            autocomplete="new-password"
                        />
                    </div>

                    <div class="mt-4">
                        <JetLabel
                            for="password_confirmation"
                            value="Confirm Password"
                        />
                        <JetInput
                            id="password_confirmation"
                            v-model="form.password_confirmation"
                            type="password"
                            class="block w-full mt-1"
                            required
                            autocomplete="new-password"
                        />
                    </div>

                    <div class="flex items-center justify-end gap-2 mt-4">
                        <JetButton
                            :class="{ 'opacity-25': form.processing }"
                            :disabled="form.processing"
                        >
                            Save
                        </JetButton>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import JetButton from '../Jetstream/Button.vue';
    import JetInput from '../Jetstream/Input.vue';
    import JetLabel from '../Jetstream/Label.vue';

    export default {
        name: 'ConfigAdmin',

        components: {
            JetButton,
            JetInput,
            JetLabel,
        },

        data() {
            return {
                form: this.$inertia.form({
                    name: null,
                    email: null,
                    password: null,
                    password_confirmation: null,
                }),
            };
        },

        methods: {
            submitForm() {
                this.form.post(route('users.management.admin.create'), {
                    onSuccess: () => {
                        this.$emit('transactionComplete');
                    },
                });
            },
        },
    };
</script>
